const RouteAssigment = {

    // FIELDS
    "customer": "Customer",
    "route": "Route",
    "search": "Search",

    // PAGE HEADER
    "customer_route_assignment": "Customer Route Assignment",

    // ERROR
    "error_customer": "Select Customer",
    "error_route": "Select Route",

    // TABLE HEADER
    "table_customer": 'CUSTOMER',
    "table_route": "ROUTE",

}

export default RouteAssigment;